import { MenuContentType as r } from "@ancon/wildcat-types";
function c(s) {
  return s.reduce(
    (t, e) => {
      var n;
      return (n = e.items) != null && n.length && (e.contentType === r.Product ? t.push(...e.items) : e.contentType === r.SubMenu && e.items.forEach((u) => {
        t.push(...u.items);
      })), t;
    },
    []
  );
}
export {
  c as default
};
